import Dashboard from "./subcomponents/Dashboard";

const ViewMrn = () =>{
    return(
        <>
        <Dashboard/>
        </>
    )
}

export default ViewMrn;